import React from 'react';
import useGameService from 'services/GameService';

import ActionButton from './ActionButton';

interface CheckProps {
  disabled: boolean;
  /**
   * Submit the action through PokerActions, handing it a closure that re-sends
   * the same action and the name the engine will record it under. That is what
   * lets a dropped action be recovered instead of the player being asked to tap
   * again. See PokerActions' submitAction.
   */
  submitAction: (send: (stamp: string) => void, name: string) => void;
  /** The emit was not acked in time (or could not be sent). PokerActions decides what happens. */
  onAckTimeout: () => void;
  triggerHideServerTimeout: () => void;
}

const CheckAction = ({
  disabled,
  submitAction,
  onAckTimeout,
  triggerHideServerTimeout
}: CheckProps) => {
  const { check } = useGameService();

  return (
    <ActionButton
      variant='check'
      icon='check'
      onClick={() => submitAction((stamp) => check(stamp, triggerHideServerTimeout, onAckTimeout), 'check')}
      disabled={disabled}>
      Check
    </ActionButton>
  );
};

export default CheckAction;
